// src/redux/userFollow/userFollowAPI.js
import apiClient from "../../authentication/utils/core/axios";

/**
 * User Follow API
 * NOTE: We don't manually check response.status — Axios resolves on 2xx (including 204)
 * and rejects on >= 300. That preserves server detail for thunks via err.response.
 */
const UserFollowAPI = {
  /**
   * Follow a user
   * POST /users/:userId/follow
   * @returns {Promise<any>} server payload (if any)
   */
  follow: async (userId) => {
    const res = await apiClient.post(`/users/${userId}/follow`);
    // If server returns 204 No Content, res.data may be empty — that's fine.
    return res.data;
  },

  /**
   * Unfollow a user
   * POST /users/:userId/unfollow
   */
  unfollow: async (userId) => {
    const res = await apiClient.post(`/users/${userId}/unfollow`);
    return res.data;
  },

  /**
   * Get users that the given user is FOLLOWING
   * GET /users/:userId/following
   * @returns {Promise<Array>} array of user objects
   */
  getFollowing: async (userId) => {
    const res = await apiClient.get(`/users/${userId}/following`);
    return res.data;
  },

  /**
   * Get users that FOLLOW the given user
   * GET /users/:userId/followers
   * @returns {Promise<Array>} array of user objects
   */
  getFollowers: async (userId) => {
    const res = await apiClient.get(`/users/${userId}/followers`);
    return res.data;
  },
};

export default UserFollowAPI;
